<template>
    <div>
    <div id="signin" class="wrapper m0-50 critical">
        <div class="section">
            <div class="div-block-15">
                <div class="form-container">
                    <div class="form-block w-form">
                        <div id="email-form" class="form-wrapper">
                            <div class="form-title-container">
                                <div class="form-title">Sign in<a href="https://prospero-uikit.webflow.io/2-content#"><strong><br></strong></a></div>
                                <p>Don&#x27;t have an account? <router-link class="link-blue" v-bind:to="'/register'">Register Now.</router-link></p>
                            </div>
                            <form @submit.prevent="sumbit">
                                <div class="input-container"  :class="{ 'hasError': $v.form.username.$error }">
                                    <label for="email" class="input-label">Email</label>
                                    <input type="email"
                                           class="text-input w-input"
                                           autofocus="true"
                                           maxlength="256"
                                           name="email"
                                           v-model="form.username"
                                           @blur="$v.form.username.$touch()"
                                           placeholder="Enter your email..."
                                           id="email" >
                                    <div class="text-red" v-if=" $v.form.username.$error">
                                        <div v-if="!$v.form.username.required">Username is required</div>
                                        <div v-if="!$v.form.username.email">Username is not a properly formatted email address</div>
                                    </div>
                                </div>
                                <div class="input-container" :class="{ 'hasError': $v.form.password.$error }">
                                    <label for="password" class="input-label">Password</label>
                                    <input type="password"
                                           class="text-input w-input"
                                           maxlength="256"
                                           name="password"
                                           data-name="password"
                                           v-model="form.password"
                                           @blur="$v.form.password.$touch()"
                                           placeholder="Enter your password..."
                                           id="password" >
                                    <div class="text-red" v-if="$v.form.password.$error">
                                        <div v-if="!$v.form.password.required">Password is required</div>
                                    </div>
                                </div>
                                <div><p><router-link class="link-blue" v-bind:to="'/forgot-password'">Forgot password</router-link></p></div>
                                <button type="submit" data-wait="Please wait..." class="submit-button w-button float-right">Sign In</button>
                            </form>
                        </div>
                        <div class="input-container form-fail" v-if="fail">
                            <div>Invalid credential. Please check your username and password.</div>
                        </div>
                        <div class="input-container form-fail" v-if="notVerified">
                            <div>Account is not verified. Please check your email for account verification link.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { userService } from '../assets/js/services/userService';
import {email, required} from "vuelidate/lib/validators";

    export default {
        name: "Login",
        data() {
            return {
                form: {
                    username: "",
                    password: ""
                },
                fail: false,
                notVerified: false
            }
        },

        validations: {
            form: {
                username: { required, email },
                password: { required }
            }
        },

        components: {
        },

        created () {
            document.title = "Sign In";//Set the document title
            userService.logout(false, this);
        },

        methods: {
            sumbit () {
                this.fail = false;
                this.notVerified = false;

                this.$v.form.$touch();
                if(this.$v.form.$error) return;
                userService.login(this.form.username, this.form.password, this)
                    .catch((error) => {
                        if (error.status === 'UNAUTHORIZED' &&
                            error.content === 'Account not verified yet' ){
                            this.notVerified = true;
                        }
                        else {
                            this.fail = true;
                        }
                    });
            },
        }
    }
</script>

<style scoped>

</style>
